export default __webpack_public_path__ + "fa9fe35bba26e5abeba3daba079e4b9a.jpg";